import { SortByOption } from 'pages/NewOrdersFlowPages/types';
import { SortDirection } from 'components/Table/types';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getCompanySuppliers } from 'services/CompanyService';
import { useQuery } from 'react-query';

export const useGetCompanySuppliers = (
  page: number,
  perPage: number,
  searchBy: string,
  sortBy?: SortByOption,
  sortDirection?: SortDirection
) =>
  useQuery({
    queryKey: [
      ReactQueryKeys.GET_COMPANY_SUPPLIERS,
      page,
      perPage,
      searchBy,
      sortBy,
      sortDirection,
    ],
    queryFn: () => {
      return getCompanySuppliers(
        page,
        perPage,
        searchBy,
        sortBy,
        sortDirection
      );
    },
  });
